export default __webpack_public_path__ + "images/dd4007669fe0e5e27bdfac84417fc058-educators_small.webp";